import { DomainsResponse } from '../../types/permissions.types'
import { mockAssignableRolesResponse } from './mockAssignableRolesResponse'

// Volunteering is view-only, so the read-only state has a fixture
export const mockDomainsResponse: DomainsResponse =
  mockAssignableRolesResponse.map((domain) => ({
    ...domain,
    canSetRoles: domain.id !== 'volunteering',
  }))
